import { call, put, takeLatest } from 'redux-saga/effects';
import { Apis } from 'src/services/api';
import { addPhaseAsync, deletePhaseAsync, getPhasesAsync, updatePhaseAsync } from './actions';

function* getPhases(api, action) {
  try {
    const employees = yield call(api, action.payload);
    yield put(getPhasesAsync.success(employees.data));
  } catch (err) {
    yield put(getPhasesAsync.failure(err));
  }
}

function* updatePhase(api, action) {
  try {
    const res = yield call(api, action.payload);
    if (res?.ok) yield put(updatePhaseAsync.success(res));
    else yield put(updatePhaseAsync.failure(res));
  } catch (err) {
    yield put(updatePhaseAsync.failure(err));
  }
}

function* addPhase(api, action) {
  try {
    const res = yield call(api, action.payload);
    if (res?.ok) yield put(addPhaseAsync.success(res));
    else yield put(addPhaseAsync.failure(res));
  } catch (err) {
    yield put(addPhaseAsync.failure(err));
  }
}

function* deletePhase(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) yield put(deletePhaseAsync.success({}));
    else yield put(deletePhaseAsync.failure(response));
  } catch (err) {
    yield put(deletePhaseAsync.failure(err));
  }
}

export default function employeesSaga(apiInstance: Apis) {
  return [
    takeLatest(getPhasesAsync.request, getPhases, apiInstance.getPhases),
    takeLatest(updatePhaseAsync.request, updatePhase, apiInstance.updatePhase),
    takeLatest(addPhaseAsync.request, addPhase, apiInstance.addPhase),
    takeLatest(deletePhaseAsync.request, deletePhase, apiInstance.deletePhase),
  ];
}
